import Link from "@components/link/link";

import { RoutineSummary } from "./routines";

const tagClassName =
  "inline-flex items-center rounded px-1.5 py-0.5 text-xs font-medium bg-gray-100 text-gray-700";

const RoutineCard = ({ routine }: { routine: RoutineSummary }) => (
  <Link
    to={`/agent/routines/${routine.key}`}
    aria-label={`Routine ${routine.name}`}
    className="block bg-white border border-gray-200 rounded-md p-3 hover:bg-gray-50 cursor-pointer"
  >
    <div className="tf-header-sm-dark">{routine.name}</div>
    <div className="text-sm text-gray-600 mt-0.5">{routine.skill}</div>
    <div className="flex flex-wrap items-center gap-1.5 mt-1.5">
      <span className={tagClassName}>{routine.scheduleLabel}</span>
      <span className={tagClassName}>Last run: {routine.lastRunLabel}</span>
    </div>
  </Link>
);

export default RoutineCard;
